module.exports = function exp (arg) {
  //  discuss at: https://locutus.io/php/exp/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: exp(0.3)
  //   returns 1: 1.3498588075760032

  return Math.exp(arg)
}
